import './SectionCard.css';

import { getSectionsInstitutions } from '../../../services/getSectionsInstitutions';
import { useSelector } from 'react-redux';
import { filterSectionsByTitle } from '../../../utils/filterSectionsByTitle';
import { useRedirect } from '../../../hooks/useRedirect';
// Translate
import { useTranslation } from 'react-i18next';

const SectionCard = () => {
  const { t } = useTranslation();
  const { redirect } = useRedirect();
  const { institutionCode, ebooksAccess } = useSelector(
    (state) => state.institution
  );

  const dataMetasearcher = getSectionsInstitutions(
    institutionCode,
    ebooksAccess
  )[0].data;
  const dataIndependient = getSectionsInstitutions(
    institutionCode,
    ebooksAccess
  )[1].data;

  const data = [...dataMetasearcher, ...dataIndependient];
  const filteredSections = filterSectionsByTitle(data);

  return (
    <div className='sections-desktop'>
      {filteredSections.map((section, i) => (
        <button
          onClick={() => redirect(section.route)}
          className='flex flex-col gap-2 w-full'
        >
          <div className='w-full rounded-3xl overflow-hidden'>
            <img
              src={section.bgImage}
              alt={section.title}
              className='w-full object-cover'
              loading='lazy'
            />
          </div>

          <p className='text-start font-semibold text-[16px]'>{t(section.title)}</p>
        </button>
      ))}
    </div>
  );
};

export default SectionCard;
